<template>
  <div class="h-100">
    <FrameMobile>
      <template v-slot:header>
        <HeaderMobile :text="header.text" :icon="header.icon" :iconLinkUrl="header.iconLinkUrl"
        :imageLoadingCompleted="imageLoadingCompleted" />
      </template>
      <template v-slot:content>
        <MainPanel @openQrcode="openQrcode" />
      </template>
      <template v-slot:footer>
        <FooterMobile :currentItem="currentFooterItem" />
      </template>
    </FrameMobile>
    <BottomSheet :isOpen.sync="isBottomSheetOpen">
      <QrcodeMobile :options="codeOptions" />
    </BottomSheet>
  </div>
</template>

<script>
import MainPanel from '@/components/mcf/MainPanel.vue';
import FooterMobile from '@/components/FooterMobile.vue';
import FrameMobile from '@/components/mcf/FrameMobile.vue';
import HeaderMobile from '@/components/mcf/HeaderMobile.vue';
import BottomSheet from '@/components/BottomSheet.vue';
import QrcodeMobile from '@/components/mcf/QrcodeMobile.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';
import commonTool from '@/utils/commonTool';

export default {
  components: {
    MainPanel,
    FooterMobile,
    FrameMobile,
    HeaderMobile,
    BottomSheet,
    QrcodeMobile,
  },
  data() {
    return {
      header: {
        text: '',
        icon: '',
        iconLinkUrl: '',
      },
      isBottomSheetOpen: false,
      codeOptions: {
        qrcode: {
          value: '',
          width: 500,
        },
        barcode: {
          value: '',
          format: 'CODE39',
        },
      },
      member: {},
      currentFooterItem: 'MemberCentreHomePage',
      // 資料是否完成載入
      imageLoadingCompleted: false,
    };
  },
  methods: {
    openQrcode() {
      this.isBottomSheetOpen = true;
    },
  },
  created() {
    const vm = this;
    vm.$store.dispatch('getMemberType')
      .then((memberType) => {
        if (memberType.qrcodeSource) vm.codeOptions.qrcode.value = memberType.qrcodeSource;
        if (memberType.barcodeSource) vm.codeOptions.barcode.value = memberType.barcodeSource;
      });
    vm.$store.dispatch('getPageSetting', 'MemberCentreHomePage')
      .then((setting) => {
        const titleWording = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = titleWording;
        vm.header.text = titleWording;
        vm.header.icon = pageSettingGetter.getFunction(setting, 'TitlePic').picUrl;

        let promise = Promise.resolve();
        // 有開啟網訊商城連結 => 前往商城；否則為原功能
        if (setting.isTEECLink) {
          promise = commonTool.getPersonalStoreUrl().toPromise().then((url) => {
            vm.header.iconLinkUrl = url;
          });
        } else { vm.header.iconLinkUrl = setting.brandLogoLinkUrl; }

        return promise;
      }).then(() => { vm.imageLoadingCompleted = true; });
    vm.$store.dispatch('getMemberData')
      .then((memberData) => {
        vm.member.name = memberData.name;
        vm.member.endTime = memberData.endTime;
      });
  },
};
</script>

<style>
.McfBgImg {
  min-height:48px;
  transform:scale(1.0) !important;
  -webkit-filter: brightness(.5) blur(0) !important;
  filter: brightness(.5) blur(0) !important;
}
</style>
